<table appScrollNearEnd (nearEnd)="onNearBottomScroll()" mat-table [dataSource]="activityLogs$ | async"
  multiTemplateDataRows class="mat-elevation-z8 media-horizontal-scroll">
  <!-- Timestamp Column -->
  <ng-container matColumnDef="timestamp">
    <th mat-header-cell *matHeaderCellDef> {{'TIMESTAMP' | translate}} </th>
    <td mat-cell *matCellDef="let element">{{element.timestamp| moment : "l LTS"}} </td>
  </ng-container>

  <!-- Area Column -->
  <ng-container matColumnDef="area">
    <th mat-header-cell *matHeaderCellDef> {{'AREA' | translate}} </th>
    <td mat-cell *matCellDef="let element"> {{'ACTIVITY_' + element.area.toUpperCase() | translate}} </td>
  </ng-container>

  <!-- User Column -->
  <ng-container matColumnDef="user">
    <th mat-header-cell *matHeaderCellDef> {{'USER' | translate }} </th>
    <td mat-cell *matCellDef="let element">
      @if (!element.staffId && element.staffName === 'Everon Admin') {
        <span
        [innerHTML]="element.staffName | escapeHighlight : searchText"></span>
      } @else {
        <a [routerLink]="['/staff', element.staffId]" data-testid="staff-link"
        [innerHTML]="(element.staffName + ' (' + element.staffId + ')' ) | escapeHighlight : searchText : true"></a>
      }
    </td>
  </ng-container>

  <!-- Action Column -->
  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef> {{'ACTION' | translate}} </th>
    <td mat-cell *matCellDef="let element">
      <div class="d-flex align-items-center">
        <app-feature-badge [feature]="$any(element.action | lowercase)"
          [status]="$safeNavigationMigration(element?.details?.translationCode) | resolveActivityBadgeStatus">
        </app-feature-badge>
        @if (element.action === 'Modify' && !($safeNavigationMigration(element?.details?.accountChanges) | propsFalsy : ['roleLevel', 'lockRights'])) {
          <i
            class="fa-solid fa-shield-halved fa-lg ml-2" style="color: #07184D" data-testid="shield-icon"
            [matTooltip]="'PERMISSIONS_MODIFIED' | translate">
          </i>
        }
      </div>
    </td>
  </ng-container>

  <!-- Details Column -->
  <ng-container matColumnDef="details">
    <th mat-header-cell *matHeaderCellDef> {{'DETAILS' | translate}} </th>
        <td mat-cell *matCellDef="let element" [innerHTML]="element.area !== 'Digital Supervision' && element.action === 'Delete' || element.action === 'Authentication' || element.action === 'Unpaired' || element.action === 'Erased' ?

            ($safeNavigationMigration(element.details?.translationCode) | translate:
                {
                    targetName: $safeNavigationMigration(element.details?.targetName) | escapeHtml,
                    targetId: $safeNavigationMigration(element.details?.targetId) | escapeHtml
                }) :

            (($safeNavigationMigration(element.details?.translationCode) | translate :
                {
                    targetName : $safeNavigationMigration(element.details?.targetName) | escapeHtml,
                    targetId: $safeNavigationMigration(element.details?.targetId) | escapeHtml,
                    start: formatLocalDateTime($safeNavigationMigration(element.details?.start)),
                    end:   formatLocalDateTime($safeNavigationMigration(element.details?.end))
                })
                | anchorWrap : $safeNavigationMigration(element.details?.targetName) : $safeNavigationMigration(element.details?.targetId) : element.area : searchText)"
      (click)="onCellClick($event)">
    </td>
    <!-- <td mat-cell *matCellDef="let element">{{element.details.targetId}}</td> -->
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"

    (click)="onRowClicked(element, $event)">[ngClass]="[element.action.toLowerCase(), element.details?.targetClass | parseTargetClass : element.action]"
  </tr>
</table>